import React from "react";

import _str from "shared/util/_str";
import getImagePath from "shared/util/getImagePath";

const OkcLoader = () => (
	<img
		style={{ width: 275 }}
		src={`${getImagePath()}media/img/loaders/okcupid.gif`}
		alt={_str("Please wait...")}
	/>
);

export default OkcLoader;



// WEBPACK FOOTER //
// ./src/shared/components/OkcLoader/index.jsx